export class SelectItem {
    constructor(
        public code: number | string,
        public name: string
    ) { }
}
